import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

/**
 * Interface for the request options.
 */
interface IRequestOptions {
  // Specifies the request's URL
  url: string;

  // Defines the HTTP method for the request
  method: string;

  // Optional: Contains the data to be sent in the request body
  data?: any;

  // Optional: Specifies the expected type of the response data
  responseType?: any;

  // Optional: Defines the encoding for the response data
  responseEncoding?: string;

  // Optional: Contains the headers to be included in the request
  headers?: Record<string, any>;

  // Contains the access token for request authorization
  accessToken: string;
}

/**
 * Generates the configuration for an Axios request.
 *
 * @param {IRequestOptions} options - The options for the request.
 * @returns {AxiosRequestConfig} - The configuration for the Axios request.
 */
const generateAxiosConfig = ({
  url,
  method,
  data,
  responseType,
  responseEncoding,
  headers,
  accessToken,
}: IRequestOptions): AxiosRequestConfig => ({
  url,
  method,
  baseURL: "",
  timeout: 20000,
  responseType,
  responseEncoding,
  data,
  headers: {
    accept: "application/json",
    Authorization: `Bearer ${accessToken}`,
    ...headers,
  },
});

/**
 * Executes an API request using Axios.
 *
 * @param {IRequestOptions} options - The options for the request.
 * @returns {Promise<AxiosResponse>} - A promise that resolves to the response of the Axios request.
 */
const executeApiRequest = async (
  options: IRequestOptions
): Promise<AxiosResponse> => axios(generateAxiosConfig(options));

export default executeApiRequest;
